import { FunctionComponent } from 'react';

import { Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { StyledButtonContainer, StyledButtonGroup } from '../styles/styled-components';

interface BreakoutRoomRowProps {
    roomName: string;
    roomId: string;
}

const JoinBreakout: FunctionComponent<BreakoutRoomRowProps> = ({ roomName, roomId }) => {
    const { t } = useTranslation('breakout_room');
    const { joinBreakout } = useContainer(BreakoutRoomOptionsContainer);

    const toolTip = `${t('join')} ${roomName}`;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();

        joinBreakout(roomId);
    };

    return (
        <StyledButtonContainer>
            <StyledButtonGroup>
                <Tooltip title={toolTip} placement="left" arrow>
                    <Button color="primary" variant="contained" onClick={handleClick} size="small">
                        {t('join')}
                    </Button>
                </Tooltip>
            </StyledButtonGroup>
        </StyledButtonContainer>
    );
};

export default JoinBreakout;
